<script setup>
  import toastTheme from '@/plugins/notivue/theme';
  import { Notification, Notivue } from 'notivue';

  const appBarTitle = ref('');

  function setAppBarTitle(title) {
    appBarTitle.value = title;
  }

  provide('setAppBarTitle', setAppBarTitle); // used by useAppBarTitle() for manual overrides
</script>

<template>
  <v-app>
    <NavDrawer />
    <AppBar :title="appBarTitle" />

    <v-main>
      <v-container class="pa-8" fluid>
        <!-- <v-row justify="center"> -->
        <!-- <v-col cols="12" md="10" lg="8" xl="8"> -->
        <slot />
        <!-- </v-col> -->
        <!-- </v-row> -->
      </v-container>
    </v-main>

    <AppFooter />

    <LogoutDialog />

    <Notivue v-slot="item">
      <Notification :item="item" :theme="toastTheme" />
    </Notivue>
  </v-app>
</template>
